/** Shared paint for crop-type maps. Only one of those layers is on at a time. */
export const CROP_AREA_COLOR = '#FFB000';

/** Same amber as `CROP_AREA_COLOR`, for TiTiler interval colormaps. */
export const CROP_AREA_COLOR_RGBA = [255, 176, 0, 255] as const;
